import * as tslib_1 from "tslib";
import FavoriteCategoryNode from '../FavoriteCategoryNode';
import FavoriteSearchNode from '../FavoriteSearchNode';
import FavoriteFolderNode from '../FavoriteFolderNode';
import FavoriteGroupNode from '../FavoriteGroupNode';
import FavoritePersonaNode from '../FavoritePersonaNode';
import { FavoritePrivateDistributionListNodeLazy } from '../FavoritePrivateDistributionListNodeLazy';
import { observer } from 'mobx-react';
import { getStore as getSharedFavoritesStore } from 'owa-favorites';
import folderStore from 'owa-folders';
import { getFavoriteNodeViewStateFromId } from 'owa-mail-favorites-store';
import getFolderViewStateFromId from 'owa-mail-folder-store/lib/selectors/getFolderViewStateFromId';
import * as React from 'react';
var FavoriteNodeV2 = /** @class */ (function (_super) {
    tslib_1.__extends(FavoriteNodeV2, _super);
    function FavoriteNodeV2() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FavoriteNodeV2.prototype.render = function () {
        var favoritesStore = getSharedFavoritesStore();
        if (favoritesStore.outlookFavoriteFolders.has(this.props.favoriteId)) {
            var favoriteFolderData = favoritesStore.outlookFavoriteFolders.get(this.props.favoriteId);
            var folderId = favoriteFolderData.folderId;
            var folder = folderStore.folderTable.get(folderId);
            var folderViewState = getFolderViewStateFromId(folderId);
            if (folder) {
                return (React.createElement(FavoriteFolderNode, { key: this.props.favoriteId, favoriteId: this.props.favoriteId, folderId: folderId, displayName: folder.DisplayName, isBeingDragged: folderViewState.drag.isBeingDragged, treeType: 'favorites' }));
            }
        }
        else if (favoritesStore.outlookFavoritePersonas.has(this.props.favoriteId)) {
            var favoritePersonaData = favoritesStore.outlookFavoritePersonas.get(this.props.favoriteId);
            if (favoritePersonaData.mainEmailAddress) {
                return (React.createElement(FavoritePersonaNode, { key: this.props.favoriteId, favoriteId: this.props.favoriteId, displayName: favoritePersonaData.displayName, emailAddress: favoritePersonaData.mainEmailAddress, personaId: favoritePersonaData.personaId, searchFolderId: favoritePersonaData.searchFolderId, isSearchFolderPopulated: favoritePersonaData.isSearchFolderPopulated, dropViewState: getFavoriteNodeViewStateFromId(this.props.favoriteId).drop, isJustAdded: false }));
            }
            else {
                return null;
            }
        }
        else if (favoritesStore.outlookFavoritePrivateDistributionLists.has(this.props.favoriteId)) {
            var favoritePdlData = favoritesStore.outlookFavoritePrivateDistributionLists.get(this.props.favoriteId);
            return (React.createElement(FavoritePrivateDistributionListNodeLazy, { key: this.props.favoriteId, favoriteId: this.props.favoriteId, displayName: favoritePdlData.displayName, searchFolderId: favoritePdlData.searchFolderId, isSearchFolderPopulated: favoritePdlData.isSearchFolderPopulated, dropViewState: getFavoriteNodeViewStateFromId(this.props.favoriteId).drop }));
        }
        else if (favoritesStore.outlookFavoriteGroups.has(this.props.favoriteId)) {
            var favoriteGroupData = favoritesStore.outlookFavoriteGroups.get(this.props.favoriteId);
            return (React.createElement(FavoriteGroupNode, { key: this.props.favoriteId, favoriteId: this.props.favoriteId, displayName: favoriteGroupData.displayName, groupId: favoriteGroupData.groupId }));
        }
        else if (favoritesStore.outlookFavoriteCategories.has(this.props.favoriteId)) {
            var favoriteCategoryData = favoritesStore.outlookFavoriteCategories.get(this.props.favoriteId);
            return (React.createElement(FavoriteCategoryNode, { key: this.props.favoriteId, favoriteId: this.props.favoriteId, categoryId: favoriteCategoryData.categoryId, dropViewState: getFavoriteNodeViewStateFromId(this.props.favoriteId).drop }));
        }
        else if (favoritesStore.outlookFavoriteSearches.has(this.props.favoriteId)) {
            var favoriteSearchData = favoritesStore.outlookFavoriteSearches.get(this.props.favoriteId);
            return (React.createElement(FavoriteSearchNode, { key: this.props.favoriteId, favoriteId: this.props.favoriteId, searchQuery: favoriteSearchData.searchQuery, dropViewState: getFavoriteNodeViewStateFromId(this.props.favoriteId).drop }));
        }
        else if (favoritesStore.outlookFavoritePublicFolders.has(this.props.favoriteId)) {
            var favoritePublicFolderData = favoritesStore.outlookFavoritePublicFolders.get(this.props.favoriteId);
            var folderViewState = getFolderViewStateFromId(favoritePublicFolderData.publicFolderId);
            return (React.createElement(FavoriteFolderNode, { key: this.props.favoriteId, favoriteId: this.props.favoriteId, displayName: favoritePublicFolderData.displayName, folderId: favoritePublicFolderData.publicFolderId, isBeingDragged: folderViewState.drag.isBeingDragged, treeType: 'favorites', isPublicFolder: true }));
        }
        // Invalid unknown data
        return null;
    };
    FavoriteNodeV2 = tslib_1.__decorate([
        observer
    ], FavoriteNodeV2);
    return FavoriteNodeV2;
}(React.Component));
export default FavoriteNodeV2;
//# sourceMappingURL=FavoriteNodeV2.js.map